import { driver } from "driver.js";
import "driver.js/dist/driver.css";

// Inline SVG icons from Lucide
const icons = {
    hand: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"/><path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"/><path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"/><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 13"/></svg>',
    refresh: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 2v6h-6"/><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M3 22v-6h6"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/></svg>',
    book: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>',
    userPlus: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" x2="19" y1="8" y2="14"/><line x1="16" x2="22" y1="11" y2="11"/></svg>',
    search: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>',
    check: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
};

const icon = (name) => `<span class="tour-icon">${icons[name]}</span>`;

const commonConfig = {
    showProgress: true,
    animate: true,
    overlayColor: 'rgba(0, 0, 0, 0.92)',
    stagePadding: 12,
    stageRadius: 16,
    popoverClass: 'orion-tour-popover',
    nextBtnText: 'Siguiente →',
    prevBtnText: '← Anterior',
    doneBtnText: '✓ ¡Entendido!',
};

/**
 * Guía para Gestión de Cursos y Docentes
 */
export const startGestionCursosTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#tour-courses-header',
                popover: {
                    title: `${icon('hand')} Gestión de Cursos`,
                    description: '<div class="tour-step-content">Aquí es donde ocurre la magia académica. En esta pantalla asignarás qué profesores enseñan en qué aulas durante este año lectivo.</div>',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#tour-generate-courses',
                popover: {
                    title: `${icon('refresh')} Generar desde Malla`,
                    description: '<div class="tour-step-content">¿El aula está vacía? No te preocupes. Haz clic aquí para <strong>crear automáticamente</strong> todos los cursos que le corresponden según la Malla Curricular ya configurada.</div>',
                    side: "left",
                    align: 'center'
                }
            },
            {
                element: '#tour-filter-aula',
                popover: {
                    title: `${icon('search')} Filtra tu Aula`,
                    description: '<div class="tour-step-content">Usa estos filtros para enfocarte en una sede o aula específica. Esto te ayudará a organizar la asignación de docentes salón por salón.</div>',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#tour-aula-card',
                popover: {
                    title: `${icon('book')} Tarjeta de Aula`,
                    description: '<div class="tour-step-content">Cada cuadro representa un aula. Puedes ver el <strong>progreso de asignación</strong> para saber cuántos cursos ya tienen profesor y cuántos faltan.</div>',
                    side: "top",
                    align: 'center'
                }
            },
            {
                element: '#tour-assign-teacher',
                popover: {
                    title: `${icon('userPlus')} Asignar Docente`,
                    description: '<div class="tour-step-content">Haz clic en este ícono para abrir el selector de profesores. ¡Recuerda que solo aparecerá el personal que ha sido marcado como "DOCENTE" en recursos humanos!</div>',
                    side: "left",
                    align: 'center'
                }
            }
        ]
    });

    driverObj.drive();
};

/**
 * Guía para Gestión de Aulas
 */
export const startAulasTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#tour-aulas-header',
                popover: {
                    title: `${icon('hand')} Gestión de Aulas`,
                    description: '<div class="tour-step-content">Bienvenido. Aquí crearás los grupos físicos (ej. "Secundaria 5to A") donde los alumnos estudiarán este año.</div>',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#tour-crear-aula',
                popover: {
                    title: `${icon('plus')} Crear Nueva Aula`,
                    description: '<div class="tour-step-content">Crea un aula nueva vinculándola a un grado y un nivel. Recuerda ponerle un nombre claro para que los padres la identifiquen.</div>',
                    side: "left",
                    align: 'center'
                }
            }
        ]
    });

    driverObj.drive();
};

/**
 * Guía para Malla Curricular
 */
export const startMallaCurricularTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#tour-malla-sidebar',
                popover: {
                    title: `${icon('hand')} Selección de Grados`,
                    description: '<div class="tour-step-content">Primero, elige el <strong>Grado</strong> que deseas configurar. Un punto verde indica que ya tiene cursos asignados.</div>',
                    side: "right",
                    align: 'start'
                }
            },
            {
                element: '#tour-malla-header',
                popover: {
                    title: `${icon('book')} Configuración de Cursos`,
                    description: '<div class="tour-step-content">Aquí defines qué materias llevará el grado seleccionado. Es la base para las libretas y el horario.</div>',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#tour-malla-subjects',
                popover: {
                    title: `${icon('check')} Activa o Desactiva`,
                    description: '<div class="tour-step-content">Haz clic en cada asignatura para incluirla o quitarla de la malla. Aparecerá un check azul cuando esté activa.</div>',
                    side: "top",
                    align: 'center'
                }
            },
            {
                element: '#tour-malla-save',
                popover: {
                    title: `${icon('refresh')} ¡No olvides guardar!`,
                    description: '<div class="tour-step-content">Cuando termines de seleccionar los cursos, haz clic en el botón flotante para aplicar los cambios permanentemente.</div>',
                    side: "top",
                    align: 'center'
                },
                padding: 4
            }
        ]
    });

    driverObj.drive();
};

/**
 * Guía para Gestión de Unidades
 */
export const startUnidadesTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#tour-unidades-header',
                popover: {
                    title: `${icon('hand')} Gestión de Unidades`,
                    description: '<div class="tour-step-content">Aquí defines la estructura temporal del año escolar (Bimestres o Trimestres). Cada unidad tiene fechas de inicio y fin que rigen el ingreso de notas.</div>',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#tour-unidades-filter-sede',
                popover: {
                    title: `${icon('search')} Filtra por Sede`,
                    description: '<div class="tour-step-content">Asegúrate de seleccionar la sede correcta, ya que las unidades pueden variar según la ubicación o el calendario regional.</div>',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#tour-unidades-view-mode',
                popover: {
                    title: `${icon('hand')} Cambia la Vista`,
                    description: '<div class="tour-step-content">¿Prefieres ver una <strong>Línea de Tiempo</strong> moderna o una <strong>Tabla</strong> tradicional? Cámbialo aquí según tu comodidad.</div>',
                    side: "left",
                    align: 'center'
                }
            },
            {
                element: '#tour-unidades-add',
                popover: {
                    title: `${icon('plus')} Nueva Unidad`,
                    description: '<div class="tour-step-content">Crea un nuevo periodo académico. Se te pedirá un número correlativo, un nombre y el rango de fechas. ¡El sistema te avisará si hay cruces!</div>',
                    side: "left",
                    align: 'center'
                }
            },
            {
                element: '#tour-unidades-content',
                popover: {
                    title: `${icon('book')} Detalle de Unidades`,
                    description: '<div class="tour-step-content">Aquí puedes ver tus unidades. Si eres administrador, haz clic en una para editar sus fechas o desactivarla si es necesario.</div>',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });

    driverObj.drive();
};

/**
 * Guía para Competencias MINEDU
 */
export const startCompetenciasTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#tour-competencias-header',
                popover: {
                    title: `${icon('hand')} Competencias MINEDU`,
                    description: '<div class="tour-step-content">Bienvenido a la gestión de Competencias y Capacidades. Aquí se define el <strong>Estándar de Aprendizaje</strong> que los docentes evaluarán.</div>',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#tour-competencias-filter',
                popover: {
                    title: `${icon('search')} Filtra por Área`,
                    description: '<div class="tour-step-content">Para una mejor organización, filtra por Área Curricular (Matemática, Comunicación, etc.) para ver solo lo que te interesa.</div>',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#tour-competencias-add',
                popover: {
                    title: `${icon('plus')} Nueva Competencia`,
                    description: '<div class="tour-step-content">Crea una competencia oficial del currículo nacional. Necesitarás el código MINEDU y el nombre oficial.</div>',
                    side: "left",
                    align: 'center'
                }
            },
            {
                element: '#tour-competencias-list',
                popover: {
                    title: `${icon('book')} Gestiona Capacidades`,
                    description: '<div class="tour-step-content">Haz clic en la flecha de cada fila para desplegar las <strong>Capacidades</strong> asociadas. También puedes agregar nuevas capacidades a cada competencia desde aquí.</div>',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });

    driverObj.drive();
};

/**
 * Guía para Movimiento de Alumnos
 */
export const startMovimientoTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#tour-movimiento-header',
                popover: {
                    title: `${icon('hand')} Movimiento de Alumnos`,
                    description: '<div class="tour-step-content">Esta herramienta permite trasladar alumnos entre aulas manteniendo la integridad de sus notas.</div>',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#tour-movimiento-filters',
                popover: {
                    title: `${icon('search')} Selección de Origen`,
                    description: '<div class="tour-step-content">Primero, filtra para encontrar al alumno que deseas mover. El sistema te mostrará solo los alumnos activos en esa aula.</div>',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#tour-movimiento-table',
                popover: {
                    title: `${icon('userPlus')} Acción de Traslado`,
                    description: '<div class="tour-step-content">Haz clic en el botón azul para iniciar el traslado. Podrás elegir el aula destino y si deseas CONGELAR o COMBINAR sus calificaciones previas.</div>',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });

    driverObj.drive();
};

/**
 * Guía para Registro de Actitud
 */
export const startActitudTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#tour-actitud-catalog',
                popover: {
                    title: `${icon('hand')} Catálogo de Actitud`,
                    description: '<div class="tour-step-content">Aquí puedes ver los Méritos y Deméritos predefinidos. Cada uno suma o resta puntos al puntaje base (AD=20).</div>',
                    side: "right",
                    align: 'start'
                }
            },
            {
                element: '#tour-actitud-filters',
                popover: {
                    title: `${icon('search')} Filtros`,
                    description: '<div class="tour-step-content">Busca por Unidad y Aula para visualizar el comportamiento de un salón específico.</div>',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#tour-actitud-register',
                popover: {
                    title: `${icon('plus')} Registro Rápido`,
                    description: '<div class="tour-step-content">Usa el botón de "+" en cada alumno para registrar una incidencia. Puedes usar el mouse o escribir el código (ej. M-01) para mayor rapidez.</div>',
                    side: "left",
                    align: 'center'
                }
            }
        ]
    });

    driverObj.drive();
};

/**
 * Guía para Sábana MINEDU
 */
export const startSabanaTour = () => {
    const driverObj = driver({
        ...commonConfig,
        steps: [
            {
                element: '#tour-sabana-filters',
                popover: {
                    title: `${icon('search')} Configura la Vista`,
                    description: '<div class="tour-step-content">Selecciona el Aula y la Unidad. El sistema calculará automáticamente los niveles de logro (AD, A, B, C) basados en el promedio de capacidades.</div>',
                    side: "bottom",
                    align: 'center'
                }
            },
            {
                element: '#tour-sabana-table',
                popover: {
                    title: `${icon('book')} Visualización Jerárquica`,
                    description: '<div class="tour-step-content">La sábana muestra las notas por <strong>Área > Competencia > Capacidad</strong>. Los colores te ayudarán a identificar rápidamente riesgos académicos.</div>',
                    side: "top",
                    align: 'center'
                }
            }
        ]
    });

    driverObj.drive();
};
